import { gql } from "@apollo/client";

export const AfiliateProgramUserFragment = gql(`
  fragment AfiliateProgramUserFragment on AfiliateProgramUserType {
    id
    status {
      enum
      display
    }
    fixedPayment {
      ...MoneyFields
    }
    variablePaymentType {
      enum
      display
    }
    variablePayment
    discountAmount
    createdAt
  }
`);

export const AfiliateProgramUserActionsFragment = gql(`
  fragment AfiliateProgramUserActionsFragment on AfiliateProgramUserType {
    ...AfiliateProgramUserFragment
    openPeriod {
      ...AfiliateProgramUserSalesPerPeriodFragment
    }
  }
`);

export const AfiliateProgramUserCodeFragment = gql(`
  fragment AfiliateProgramUserCodeFragment on AfiliateProgramUserCodeType {
    id
    totalSales {
      ...MoneyFields
    }
    totalDiscounts {
      ...MoneyFields
    }
    timesUsed
    discountCodes {
      id
      discountCode {
        id
        code
        usage
      }
      period {
        ...DateTimeRangeFragment
      }
    }
    lastTimeUsed
  }
`);

export const EcommerceStoreFragment = gql(`
  fragment EcommerceStoreFragment on SocialNetworkUserType {
    id
    username
    name
    platform {
      id
      code
      enumCode
      name
      image {
        ...FileFields
      }
    }
  }
`);

export const EcommerceDiscountCodeFragment = gql(`
  fragment EcommerceDiscountCodeFragment on EcommerceDiscountCodeType {
    id
    title
    status
    percentage
    startsAt
    endsAt
    combinesWithOrderDiscounts
    combinesWithProductDiscounts
    combinesWithShippingDiscounts
    collections {
      ...EcommerceCollectionFragment
    }
    isActive
    socialNetworkUser {
      ...EcommerceStoreFragment
    }
  }
`);

export const AfiliateProgramBenefitFragment = gql(`
  fragment AfiliateProgramBenefitFragment on AfiliateProgramBenefitType {
    id
    icon {
      enum
      display
    }
    label
    order
  }
`);

export const AfiliateProgramPeriodicRewardFragment = gql(`
  fragment AfiliateProgramPeriodicRewardFragment on AfiliateProgramPeriodicRewardType {
    id
    metric {
      enum
      display
    }
    period {
      enum
      display
    }
    thresholdValue
    rewardCount
    label
  }
`);

export const AfiliateProgramFragment = gql(`
  fragment AfiliateProgramFragment on AfiliateProgramType {
    id
    name
    shortName
    description
    since
    until
    code
    order
    objective {
      enum
      display
    }
    productPaymentOption {
      enum
      display
    }
    contentElaboration {
      enum
      display
    }
    fixedPayment {
      ...MoneyFields
    }
    variablePaymentType {
      enum
      display
    }
    variablePercentagePayment
    discountPercentage
    programColor
    highlightColor
    programTextColor
  }
`);

export const AfiliateProgramContentFragment = gql(`
  fragment AfiliateProgramContentFragment on AfiliateProgramContentType {
    id
    uploader {
      enum
      display
    }
    postType {
      ...PostTypeFields
    }
    description
    references {
      ...CampaignReferenceFields
    }
    uploadTimeframe {
      enum
      display
    }
  }
`);

export const EcommerceProductFragment = gql(`
  fragment EcommerceProductFragment on EcommerceProductType {
    id
    maxPrice {
      ...MoneyFields
    }
    minPrice {
      ...MoneyFields
    }
    url
    previewUrl
    title
    featuredImage
    description
  }
`);
export const EcommerceProductNameFragment = gql(`
  fragment EcommerceProductNameFragment on EcommerceProductType {
    id
    title
  }
`);

export const EcommerceCollectionFragment = gql(`
  fragment EcommerceCollectionFragment on EcommerceCollectionType {
    id
    title
    description
    image
    productsCount
  }
`);

export const AfiliateProgramPriceProductFragment = gql(`
  fragment AfiliateProgramPriceProductFragment on AfiliateProgramPriceProductType {
    id
    delivery {
      enum
      display
    }
    product {
      ...EcommerceProductFragment
    }
  }
`);

export const AfiliateProgramUserSalesPerPeriodFragment = gql(`
  fragment AfiliateProgramUserSalesPerPeriodFragment on AfiliateProgramUserSalesPerPeriodType {
    id
    period {
      ...DateTimeRangeFragment
    }
    sales {
      ...MoneyFields
    }
    commission {
      ...MoneyFields
    }
    count
    status {
      enum
      display
    }
  }
`);

export const AfiliateProgramUserSalesPerPeriodWithSalesFragment = gql(`
  fragment AfiliateProgramUserSalesPerPeriodWithSalesFragment on AfiliateProgramUserSalesPerPeriodType {
    ...AfiliateProgramUserSalesPerPeriodFragment
    afiliateprogramusersaleSet {
      ...AfiliateProgramUserSaleFragment
    }
  }
`);

export const CommissionPeriodFragment = gql(`
  fragment CommissionPeriodFragment on AfiliateProgramUserCommissionPeriodType {
    id
    period {
      ...DateTimeRangeFragment
    }
    variablePayment
    reason
    groupId
  }
`);

export const CommissionPeriodGroupFragment = gql(`
  fragment CommissionPeriodGroupFragment on CommissionPeriodGroupType {
    id
    period {
      ...DateTimeRangeFragment
    }
    variablePayment
    reason
    programs
  }
`);

export const AfiliateProgramUserRefFragment = gql(`
  fragment AfiliateProgramUserRefFragment on AfiliateProgramUserRefType {
    id
    ref {
      id
      urlWithRef
    }
  }
`);

export const AfiliateProgramUserSaleFragment = gql(`
  fragment AfiliateProgramUserSaleFragment on AfiliateProgramUserSaleType {
    id
    commission {
      ...MoneyFields
    }
    orderedAt
    location
    movementType {
      enum
      display
    }
    invalidReason {
      enum
      display
    }
  }
`);

export const AfiliateProgramTransitionFragment = gql(`
  fragment AfiliateProgramTransitionFragment on AfiliateProgramTransitionType {
    id
    active
    conditions {
      attribute
      operator
      period
      value
    }
    fromProgram {
      ...AfiliateProgramFragment
    }
    toProgram {
      ...AfiliateProgramFragment
    }
  }
`);

export const TopSellerTypeFragment = gql(`
  fragment TopSellerTypeFragment on TopSellerType {
    id
    photo
    title
    count
    amount {
      ...MoneyFields
    }
    productPhoto {
      ...FileFields
    }
    productUrl
  }
`);
